import { isNumber, memoize } from "lodash";
import { observable, runInAction } from "mobx";

import { apiCallGetAdminEventsStatistics } from "../../../api/auditor-api/api-call-get-admin-events-statistics";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { TDataRow } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import i18n from "../../../constants/i18n";
import { reduce } from "et3-type-guards";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class EventsChartStore {
  adminInput = observable.box<TEt3PickerSingleValue>({
    value: "",
    label: i18n.get("CHOOSE")
  });
  limitInput = observable.box<TEt3PickerSingleValue>({
    label: "50",
    value: "50"
  });
  typeInput = observable.box<TEt3PickerSingleValue>({
    label: "All",
    value: "all"
  });
  dateMinInput = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  setAdmin = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.adminInput.set(admin);
    });
  };
  setTypeInput = (type: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.typeInput.set(type);
    });
  };
  setLimitInput = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.limitInput.set(limit);
    });
  };
  dateMaxInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  adminEventsChartsData = observable.box<{
    eventsStatistics: { customDate: Date; total: number }[];
    dailyStatistics: TDataRow[];
  }>({
    eventsStatistics: [],
    dailyStatistics: []
  });

  getEventsChart = async () => {
    this.adminEventsChartsData.set({
      eventsStatistics: [],
      dailyStatistics: []
    });

    const definedAdminID = reducerToZeroIfUndefined(
      parseInt(this.adminInput.get().value, 10)
    );
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.limitInput.get().value, 10)
    );
    if (!isNumber(definedAdminID)) {
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_EVENTS_CHARTS", true);
    const { data, status, code } = await apiCallGetAdminEventsStatistics({
      adminId: definedAdminID,
      dateMin: this.dateMinInput.get(),
      dateMax: this.dateMaxInput.get(),
      type: this.typeInput.get().value,
      limit: definedLimit
    });
    getCoreUIStore().setIsLoading("AUDITOR_EVENTS_CHARTS", false);
    if (status === "OK") {
      this.adminEventsChartsData.set(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  getEventsChartTableDailyStatistcs = () => {
    const finalizedData = this.adminEventsChartsData
      .get()
      .dailyStatistics.map((e) => {
        return {
          stat_0: reduce(() => e[0], 0),
          stat_1: reduce(() => e[1], 0),
          stat_2: reduce(() => e[2], 0),
          stat_3: reduce(() => e[3], 0),
          stat_4: reduce(() => e[4], 0),
          stat_5: reduce(() => e[5], 0),
          stat_6: reduce(() => e[6], 0),
          stat_7: reduce(() => e[7], 0),
          stat_8: reduce(() => e[8], 0),
          stat_9: reduce(() => e[9], 0),
          stat_10: reduce(() => e[10], 0),
          stat_11: reduce(() => e[11], 0),
          stat_12: reduce(() => e[12], 0),
          stat_13: reduce(() => e[13], 0),
          stat_14: reduce(() => e[14], 0),
          stat_15: reduce(() => e[15], 0),
          stat_16: reduce(() => e[16], 0),
          stat_17: reduce(() => e[17], 0),
          stat_18: reduce(() => e[18], 0),
          stat_19: reduce(() => e[19], 0),
          stat_20: reduce(() => e[20], 0),
          stat_21: reduce(() => e[21], 0),
          stat_22: reduce(() => e[22], 0),
          stat_23: reduce(() => e[23], 0),
          stat_date: reduce(() => e["key"], "")
        };
      });
    return finalizedData;
  };
}

const getEventsChartStore = memoize(
  () => new EventsChartStore(),
  () => 1
);
export default getEventsChartStore;
